<template>
    <div>
        <section class="section">
            <div class="container">
                <div class="container content_call_to_action_container">
                    <div class="row align-items-center">
                        <div class="col-md-8">
                            <h3 class="content_call_to_action_container_h3">
                                {{ heading }}
                            </h3>
                            <p class="content_call_to_action_container_p">
                                {{ message }}
                            </p>
                        </div>
                        <div class="col-md-4">
                            <a :href="linkUrl" class="btn btn--call-to-action">
                                {{ linkText }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        props: {
            heading: {
                type: String
            },
            message: {
                type: String
            },
            linkUrl: {
                type: String,
                default: '/'
            },
            linkText: {
                type: String,
                default: 'Voit siirtyä tästä etusivulle'
            }
        }
    };
</script>
